import type { FC } from 'react';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UnderlinedTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import {
  getCurrentProductsSectionType,
  getIsPublishedDataset,
} from '../../../selectors/studio';
import { ProductType } from '../types';

interface Props {
  className?: string;
}

const ProductsTabs: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const isPublishedDataset = useSelector(getIsPublishedDataset);
  const productType = useSelector(getCurrentProductsSectionType);
  let unlistedLabel = t('studio.products.tabs.unlisted');
  let unlistedHref;
  let publishedHref;

  switch (productType) {
    default:
    case ProductType.Tier:
      publishedHref = Url.studio({ products: 'tier' });
      unlistedHref = Url.studio({ products: 'tier-unlisted' });
      unlistedLabel = t('studio.products.tabs.drafts');
      break;
    case ProductType.PremiumDownload:
      publishedHref = Url.studio({ products: 'pcp' });
      unlistedHref = Url.studio({ products: 'pcp-unlisted' });
      break;
    case ProductType.Exclusive:
      publishedHref = Url.studio({ products: 'exclusive' });
      unlistedHref = Url.studio({ products: 'exclusive-unlisted' });
      break;
    case ProductType.Original:
      publishedHref = Url.studio({ products: 'originals' });
      unlistedHref = Url.studio({ products: 'originals-drafts' });
      unlistedLabel = t('studio.products.tabs.drafts');
      break;
  }

  const activeTab = isPublishedDataset ? 'published' : 'unlisted';
  const tabs = [
    {
      index: 'published',
      label: t('studio.products.tabs.published'),
      href: publishedHref,
    },
    {
      index: 'unlisted',
      label: unlistedLabel,
      href: unlistedHref,
    },
  ];

  return (
    <UnderlinedTabs
      className={className}
      activeIndex={activeTab}
      items={tabs}
      uniformTabWidth={isMobile}
    />
  );
};
ProductsTabs.displayName = 'ProductsTabs';

export default ProductsTabs;
